// These should match bootstrap_theme.scss $grid-breakpoints.
export const breakpoints = {
  lg: 915,
  md: 768,
  sm: 550,
  xl: 1200,
  xs: 370,
};

export const breakpointPixels = {
  lg: `${breakpoints.lg}px`,
  md: `${breakpoints.md}px`,
  sm: `${breakpoints.sm}px`,
  xl: `${breakpoints.xl}px`,
  xs: `${breakpoints.xs}px`,
};

export const contentMaxWidth = "1440px";
